import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { URLSearchParams } from '@angular/http';

import {
  ConfiguracoesProjeto,
  PaginatedList,
  ParametrosService,
  PremioSorteioModel,
  RelacaoGanhadoresSorteio,
  SituacaoSorteioModel,
  SorteioConsumidorModel,
  SorteioModel,
  TipoSorteioModel,
} from '../../../shared';
import { GenericHttpService } from '../../../shared/generic-http.service';
import { DetalheSorteioTipoModel } from './../../../shared/model/detalhe-sorteio-tipo.model';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { DetalheSorteioModel } from '../../../shared/model/detalhe-sorteio.model';
import { FiltroDetalheSorteioConsumidor } from '../../../shared/filter/filtro-detalhes-sorteio-consumidor';
import { PeriodoSorteioMensalAtual } from '../../../shared/model/periodo-sorteio-atual.model';
import { FiltroBuscaPaginacao } from '../../../shared/filter/filtro-busca-paginacao';
import { SorteioEspecialModel } from '../../../shared/model/sorteio-especial';
import { FiltroListarSorteiosPorTipoESituacaoPortal } from '../../../shared/model/filtro-listar-sorteio-por-tipo-e-situacao';

@Injectable()
export class SorteioService {
  private _urlBase: string;

  private _urlBaseSorteioConsumidor: string;

  //private _urlBaseDetalhes: string;
  private _uri_docsnbp: string;

  public detalhesSorteiosChange = new Subject<Array<DetalheSorteioTipoModel>>();
  public sorteiosEspeciaisChange = new Subject<Array<SorteioEspecialModel>>();
  public tiposSorteioChange = new Subject<Array<TipoSorteioModel>>();
  public situacoesSorteioChange = new Subject<{ tipo: number; situacoes: Array<SituacaoSorteioModel> }>();
  public sorteiosChange = new Subject<{ tipo: number; situacao: number; sorteios: PaginatedList<SorteioModel> }>();

  public sorteioModelSelected = new Subject<SorteioModel>();

  public detalheSorteioModelSelected = new Subject<DetalheSorteioModel>();

  public SorteioConsumidorModelSelected = new Subject<SorteioConsumidorModel>();

  public premiosSorteioSelected = new Subject<Array<PremioSorteioModel>>();
  public consumidorPremiado = new Subject<Array<RelacaoGanhadoresSorteio>>();
  public configuracao: ConfiguracoesProjeto;

  public abaTipoSorteioSelecionada = null;

  public codSorteio = 0;

  constructor(
    private readonly tipoSorteioHttpService: GenericHttpService<TipoSorteioModel>,
    private readonly situacaoSorteioHttpService: GenericHttpService<SituacaoSorteioModel>,
    private readonly sorteioConsumidorHttpService: GenericHttpService<SorteioConsumidorModel>,
    private readonly sorteioHttpService: GenericHttpService<SorteioModel>,
    private readonly detalheSorteioHttpService: GenericHttpService<DetalheSorteioModel>,
    private readonly sorteioEspecialHttpService: GenericHttpService<SorteioEspecialModel>,
    private readonly premioHttpService: GenericHttpService<PremioSorteioModel>,
    private readonly consumidorSorteadoService: GenericHttpService<RelacaoGanhadoresSorteio>,
    private readonly qtdBilhetesService: GenericHttpService<number>,
    private readonly ngbModalService: NgbModal,
    private readonly parametroService: ParametrosService,
    private readonly loadingService: LoadingService,
    private readonly detalhesSorteios: GenericHttpService<DetalheSorteioTipoModel>,
  ) {
    this.configuracao = this.parametroService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'sorteio';
  }

  get urlBase() {
    this.configuracao = this.parametroService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'sorteio';
    return this._urlBase;
  }

  get urlBaseSorteioConsumidor() {
    this.configuracao = this.parametroService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'sorteio-consumidor';
    return this._urlBase;
  }

  get urlBaseDetalhes() {
    this.configuracao = this.parametroService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'detalhe-sorteio';
    return this._urlBase;
  }

 get uriDocsnbp() {
    this.configuracao = this.parametroService.getConfiguracao();
    this._uri_docsnbp = this.configuracao.uri_docsnbp;
    return this._uri_docsnbp;
  }

  public getDetalheSorteioById(id: number): void {
    this.loadingService.exibirLoading("Aguarde");
    const s: Subscription = this.detalheSorteioHttpService.getById(this.urlBase + `/detalhe/${id}`).subscribe(
      (data: DetalheSorteioModel) => {
        this.detalheSorteioModelSelected.next(data);
      },
      (error: any) => {
        this.detalheSorteioModelSelected.next(null);
        this.loadingService.esconderLoading();
      },
      () => {
        s.unsubscribe();
        this.loadingService.esconderLoading();
      }
    );
  }

  private obterParametrosBuscaDetalhesSorteioConsumidor(filtro: FiltroDetalheSorteioConsumidor) : URLSearchParams {
    const params: URLSearchParams = new URLSearchParams();
    params.append('sorteioId', filtro.sorteioId.toString());
    params.append('consumidorId', filtro.consumidorId.toString());
    return params;
  }

  public detalharSorteioConsumidor(filtro: FiltroDetalheSorteioConsumidor): void {
    this.loadingService.exibirLoading("Aguarde");

    let parametrosBusca = this.obterParametrosBuscaDetalhesSorteioConsumidor(filtro);

    const s: Subscription = this.sorteioConsumidorHttpService
      .getAny(this.urlBaseDetalhes + `/detalhe-sorteio-consumidor`, parametrosBusca)
      .subscribe(
        (data: SorteioConsumidorModel) => {
          this.SorteioConsumidorModelSelected.next(data);
        },
        (error: any) => {
          this.SorteioConsumidorModelSelected.next(null);
          this.loadingService.esconderLoading();
        },
        () => {
          s.unsubscribe();
          this.loadingService.esconderLoading();
        }
      );
  }

  public getQuantidadeBilhetesSorteio(id: number): Observable<number> {
    return this.qtdBilhetesService.getAny(this.urlBase + `QuantidadeBilhetes/${id}`);
  }

  public getRelatorioRelacaoSorteados(seqSorteio: number): void {
    window.open(this.urlBase.concat(`/RelatorioRelacaoGanhadores/${seqSorteio}`), '', 'toolbar=no, location=no');
  }

  public getRelatorioRelacaoPremiados(seqSorteio: number): void {
    window.open(this.urlBase.concat(`/RelatorioRelacaoPremiados/${seqSorteio}`), '', 'toolbar=no, location=no');
  }

  public getDetalhesSorteios(filtro: FiltroBuscaPaginacao): void {
    this.loadingService.exibirLoading('Aguarde enquanto os sorteios estão sendo consultados.'); 

    let parametrosDetalhamentoSorteios = this.obterParametrosBuscaDetalhamentoSorteios(filtro);

    const s: Subscription = this.detalhesSorteios.getAllParamFull(this.urlBase + `/detalhamento-sorteios/`, parametrosDetalhamentoSorteios).subscribe(
      (data: Array<DetalheSorteioTipoModel>) => {
        this.detalhesSorteiosChange.next(data.slice());
      },
      (error: any) => {
        this.detalhesSorteiosChange.next([]);
        this.loadingService.esconderLoading();
      },
      () => {
        s.unsubscribe();
        this.loadingService.esconderLoading();
      }
    );
  }

  private obterParametrosBuscaDetalhamentoSorteios(filtro: FiltroBuscaPaginacao) : URLSearchParams {
    const params: URLSearchParams = new URLSearchParams();
    params.append('page', filtro.page.toString());
    params.append('pageSize', filtro.pageSize.toString());
    return params;
  }

  public getTiposSorteio(): void {
    const s: Subscription = this.tipoSorteioHttpService.getAll(this.urlBase + `/tipos`).subscribe(
      (data: Array<TipoSorteioModel>) => {
        this.tiposSorteioChange.next(data.slice());
      },
      (error: any) => {
        this.tiposSorteioChange.next([]);
      },
      () => {
        s.unsubscribe();
      }
    );
  }

  public getSorteiosEspeciais(): void {
    this.loadingService.exibirLoading('Aguarde enquanto os sorteios estão sendo consultados.');
    const s: Subscription = this.sorteioEspecialHttpService.getAll(this.urlBaseSorteioConsumidor + `/listagem-sorteios-especiais`).subscribe(
      (data: Array<SorteioEspecialModel>) => {
        this.sorteiosEspeciaisChange.next(data.slice());
      },
      (error: any) => {
        this.sorteiosEspeciaisChange.next([]);
        this.loadingService.esconderLoading();
      },
      () => {
        s.unsubscribe();
        this.loadingService.esconderLoading();
      }
    );
  }


  public getSorteiosRealizados(page: number, pageSize: number, tipoSorteio: number) :  Subject<PaginatedList<SorteioModel>> {

    let sorteiosRealizadosModel = new Subject<PaginatedList<SorteioModel>>();

    this.loadingService.exibirLoading("Aguarde");

    const filtro = this.ObterSearchSorteiosRealizados(page, pageSize, tipoSorteio);

    const s: Subscription = this.sorteioHttpService
      .get(this.urlBase + '/realizados/', filtro)
      .subscribe(
        (data: PaginatedList<SorteioModel>) => {
          sorteiosRealizadosModel.next(new PaginatedList<SorteioModel>(data.totalCount, data.list.slice()));
        },
        (error: any) => {
          sorteiosRealizadosModel.next(new PaginatedList<SorteioModel>(0, []));
          this.loadingService.esconderLoading();
        },
        () => {
          s.unsubscribe();
          this.loadingService.esconderLoading();
        }
      );
      return sorteiosRealizadosModel;

  }

  private ObterSearchSorteiosRealizados(page: number, pageSize: number, tipoSorteio: number) : URLSearchParams {

    const params: URLSearchParams = new URLSearchParams();

    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    params.append('tipoSorteio', tipoSorteio.toString());

    return params;
  }

  private sorteioChange(_tipo: number, _situacao: number, data: PaginatedList<SorteioModel>, _sucesso: boolean) {
    if (_sucesso) {
      this.sorteiosChange.next({
        tipo: _tipo,
        situacao: _situacao,
        sorteios: new PaginatedList<SorteioModel>(data.totalCount, data.list.slice())
      });
    } else {
      this.sorteiosChange.next({ tipo: _tipo, situacao: _situacao, sorteios: new PaginatedList<SorteioModel>(0, []) });
    }
  }

  public getPeriodoSorteioAtual(): Observable<PeriodoSorteioMensalAtual> {
    return this.qtdBilhetesService.getAny(this.urlBaseSorteioConsumidor + `/periodo-sorteio-atual`);
  }

  public getSorteiosPorSituacaoETipoPortal(filtro: FiltroListarSorteiosPorTipoESituacaoPortal): void {
    this.loadingService.exibirLoading("Aguarde");
    const parametrosBusca = this.obterParametrosSorteiosPorSituacaoETipoPortal(filtro);
    const s: Subscription = this.sorteioHttpService
      .getAny(this.urlBase + `/listagem`, parametrosBusca)
      .subscribe(
        (data: PaginatedList<SorteioModel>) => {
          this.sorteioChange(filtro.tipoSorteio, filtro.situacaoSorteio, data, true);
        },
        (error: any) => {
          this.sorteioChange(filtro.tipoSorteio, filtro.situacaoSorteio, null, false);
          this.loadingService.esconderLoading();
        },
        () => {
          s.unsubscribe();
          this.loadingService.esconderLoading();
        }
      );
  }

  private obterParametrosSorteiosPorSituacaoETipoPortal(filtro: FiltroListarSorteiosPorTipoESituacaoPortal) : URLSearchParams {
    const params: URLSearchParams = new URLSearchParams();
    params.append('tipoSorteio', filtro.tipoSorteio.toString());
    params.append('situacaoSorteio', filtro.situacaoSorteio.toString());
    params.append('page', filtro.page.toString());
    params.append('pageSize', filtro.pageSize.toString());
    return params;
  }
 
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/shared/sorteio.service.ts